import { Box } from '@mui/material';
import { Title } from '@routific/hive';
import { useTranslation } from 'react-i18next';


const DownloadCSVModalTitle: React.FC = () => {
  const { t } = useTranslation('components');

  return (
    <Box display="flex" gap={2} flexDirection="row" alignItems="center">
      <Title level={4}>{t('downloadCSV.modal.title')}</Title>
    </Box>
  );
};

export default DownloadCSVModalTitle;
